const getOrganicProductCount = (productIdCollection, adsConfig) => {
  if (!productIdCollection) return undefined;

  const { advertPositions } = adsConfig;
  return productIdCollection.length - advertPositions.length;
};

export default getOrganicProductCount;
